import { __awaiter, __generator } from "tslib";
import axios from 'axios';
import * as HttpFunctions from './http.functions';
var HttpService = /** @class */ (function () {
    function HttpService(opts) {
        this.opts = opts;
        this.axiosInstance = axios.create(opts === null || opts === void 0 ? void 0 : opts.axiosRequestConfig);
        this.functionsConfig = this.getFunctionsConfig();
    }
    HttpService.prototype.getAsync = function (call, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpFunctions.getWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.postAsync = function (call, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpFunctions.postWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.putAsync = function (call, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpFunctions.putWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.patchAsync = function (call, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpFunctions.patchWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.deleteAsync = function (call, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, HttpFunctions.deletehWithRetryAsync(this.axiosInstance, call, this.functionsConfig, options)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    HttpService.prototype.createCancelToken = function () {
        return HttpFunctions.createCancelToken();
    };
    HttpService.prototype.getFunctionsConfig = function () {
        var _a, _b;
        return {
            logErrorsToConsole: (_b = (_a = this.opts) === null || _a === void 0 ? void 0 : _a.logErrorsToConsole) !== null && _b !== void 0 ? _b : true
        };
    };
    return HttpService;
}());
export { HttpService };
//# sourceMappingURL=http.service.js.map